module.exports = require('./lib/jwt');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jwt-simple/index.js
 ** module id = 1236
 ** module chunks = 0
 **/